import {
  GET_FACEBOOK_URL_INFO,
  GET_FACEBOOK_URL_INFO_SUCCESS,
  GET_FACEBOOK_URL_INFO_FAIL,
  GET_VK_URL_INFO,
  GET_VK_URL_INFO_SUCCESS,
  GET_VK_URL_INFO_FAIL,
} from '../actions/social';

const initialState = {
  fbInfoByUrl: {},
  vkInfoByUrl: {},
}

export default function social(state = initialState, action = {}) {
  switch (action.type) {
    case GET_FACEBOOK_URL_INFO:
      return {
        ...state,
        fbInfoByUrl: {
          ...state.fbInfoByUrl,
          [action.additional.url]: null,
        },
      };

    case GET_FACEBOOK_URL_INFO_SUCCESS:
      return {
        ...state,
        fbInfoByUrl: {
          ...state.fbInfoByUrl,
          [action.additional.url]: action.response,
        },
      };

    case GET_FACEBOOK_URL_INFO_FAIL:
      return {
        ...state,
        fbInfoByUrl: {
          ...state.fbInfoByUrl,
          [action.additional.url]: false,
        },
      };

    case GET_VK_URL_INFO:
      return {
        ...state,
        vkInfoByUrl: {
          ...state.vkInfoByUrl,
          [action.additional.url]: null,
        },
      };

    case GET_VK_URL_INFO_SUCCESS:
      return {
        ...state,
        vkInfoByUrl: {
          ...state.vkInfoByUrl,
          [action.additional.url]: action.response,
        },
      };

    case GET_VK_URL_INFO_FAIL:
      return {
        ...state,
        vkInfoByUrl: {
          ...state.vkInfoByUrl,
          [action.additional.url]: false,
        },
      };

    default:
      return state;
  }
}
